import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { GetReceiptManagementEnabledResponse } from 'src/queries/organizations/receiptManagement/receiptManagement.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getReceiptManagementEnabled = async (
  orgId: string,
): Promise<GetReceiptManagementEnabledResponse> => {
  return getResponseData(
    axios.get<GetReceiptManagementEnabledResponse>(
      `/organizations/${orgId}/receiptmanagementenabled`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
